import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  filters: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_FILTER:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false,
      }

    case ActionTypes.RECEIVE_FILTER:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        filters: action.filters,
      }

    case ActionTypes.ERROR_FILTER:
      return {
        ...state,
        isFetching: false,
        didInvalidate: true,
      }

    case ActionTypes.REQUEST_APPNAME:
      return {
        ...state,
      }
      
    case ActionTypes.RECEIVE_APPNAME:
      return {
        ...state,
        userNames: action.userNames,
        departmentNames : action.departmentNames,
        sectionNames : action.sectionNames,
        pcNames: action.pcNames,
        hpa27Names : action.hpa27Names,
        appNames: action.appNames,
        lastUpdated: action.receivedAt
      };

    case ActionTypes.REQUEST_FILTER_DATAS:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        // filter_items: action.filter_items,
        // filterDatas:action.filterDatas,
      }

    case ActionTypes.RECEIVE_FILTER_DATAS:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        // filter_items: action.filter_items,
        filterDatas: action.filterDatas,
      }

    default:
      return state
  }
}